var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 0H2.44444C1.08889 0 0 1.02222 0 2.28889V13.7778C0 15.0444 1.08889 16.0667 2.44444 16.0667H4.04444V19.4667C4.04444 19.6667 4.17778 19.8667 4.37778 19.9556C4.46667 20 4.53333 20 4.62222 20C4.75556 20 4.88889 19.9556 5 19.8889L10.0444 16.0667H17.5556C18.9111 16.0667 20 15.0444 20 13.7778V2.28889C20 1.02222 18.9111 0 17.5556 0ZM18.8667 13.7556C18.8667 14.4222 18.2889 14.9556 17.5778 14.9556H9.82222C9.68889 14.9556 9.55556 15 9.44444 15.0667L5.2 18.2889V15.4889C5.2 15.2 4.93333 14.9556 4.62222 14.9556H2.44444C1.73333 14.9556 1.15556 14.4222 1.15556 13.7556V2.33333C1.15556 1.66667 1.73333 1.13333 2.44444 1.13333H17.6C18.3111 1.13333 18.8889 1.66667 18.8889 2.33333V13.7556H18.8667Z",
    fill: "#2E397E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77767 8.37784H8.93323V7.26673H5.77767V5.88895H9.19989V4.7334H4.44434V11.2223H9.35545V10.0445H5.77767V8.37784Z",
    fill: "#2E397E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3984 9.26673L11.8207 4.7334H10.3984V11.2223H11.6651V6.62229L14.3095 11.2223H15.6651V4.7334H14.3984V9.26673Z",
    fill: "#2E397E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.b9aed9dcbf1789a10690d01f248fcefb.svg";
export { ForwardRef as ReactComponent };